import { render } from "./TeamLogoBadge.vue?vue&type=template&id=53050d31&scoped=true"
import script from "./TeamLogoBadge.vue?vue&type=script&lang=js"
export * from "./TeamLogoBadge.vue?vue&type=script&lang=js"

import "./TeamLogoBadge.vue?vue&type=style&index=0&id=53050d31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53050d31"]])

export default __exports__